module.exports = __webpack_public_path__ + "img/suger.0328a7a9.svg";